// test1528
(1528 && 0);
